/**
 * An allocation this component invented rather than one the server sent, carrying
 * a generated `new_` id until it is saved.
 *
 * Shared between ActualCostsAllocationRow (which creates, adopts and drops these)
 * and ActualCostsAllocationSubRow (which reads the distinction to decide what a
 * cell can safely show or offer to copy), so the definition cannot drift between
 * the two files.
 */
export const isPlaceholderAllocation = (allocation) => allocation.id.toString().startsWith('new_');

/**
 * The Contract Reference dropdown's "Send for commitment" entry.
 *
 * Every other value in that dropdown is a real contract's typed id, which the
 * row stores as `typed_contractable_id` and the server resolves back to a model.
 * This one is not a contract, so it must never travel that way: getContractableData()
 * assigns `contractable_id` from any `x::y` string but resolves `contractable_type`
 * to null on a prefix it does not know, which persists an orphan id. It is read in
 * ActualCostsAllocationRow's changeContractable and turned into the allocation's
 * own `send_for_commitment` boolean instead.
 *
 * Deliberately not `prefix::id` shaped, so it cannot be mistaken for one.
 */
export const SEND_FOR_COMMITMENT_OPTION = '__send_for_commitment__';
